/******************************************************************************
 * PhotoCategoryAdminActions: per-row edit action for a photo category.
 * Hosts the edit drawer and issues PUT admin/photo_categories/{id}.
 *****************************************************************************/

/* Imports */
import toast from "react-hot-toast";
/***/

/* Components */
import EditCreateDrawer from "../../edit-create-drawer/EditCreateDrawer";
import PhotoCategoryForm from "./PhotoCategoryForm";
import { api } from "../../../services/api/api";
import { showApiErrorToast } from "../../../services/api/error";
import { buildPhotoCategoryPayload, isValidCategory } from "./photoCategoryPayload";
/***/

/**
* PhotoCategoryAdminActions: edit action for a photo category
* @param category - category data
* @param onChange - reload callback
*/
export default function PhotoCategoryAdminActions({
  category,
  onChange
}: {
  category: EasyTech.PhotoCategory,
  onChange: () => void
}) {
  /**
  * updateCategory: update a photo category
  * @param data - category data to update
  */
  const updateCategory = (data: EasyTech.PhotoCategory): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (data && data.id && isValidCategory(data)) {
        api.put("admin/photo_categories/" + data.id, buildPhotoCategoryPayload(data)).then(() => {
          onChange();
          toast.success("Photo category updated");
          return resolve();
        }).catch((error: any) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Error while updating the photo category" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return (
    <div className="admin-wo-actions">
      <EditCreateDrawer data={(category as EasyTech.PhotoCategory)}
        entityName="Photo category"
        FormComponent={PhotoCategoryForm}
        isNotCreatable={true}
        onSubmit={updateCategory} />
    </div>
  );
}
/***/
